import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import React, { memo } from "react";

function Footer() {
  return (
    <Box component={"footer"} bgcolor={"#fff"}>
      <Divider />
      {/* <Container> */}
        <Box textAlign={"center"} py={2.5}>
          Mortgage Street © {new Date().getFullYear()}.{" "}
        </Box>
      {/* </Container> */}
    </Box>
  );
}

export default memo(Footer);
